import { STYLE_OPTIONS } from 'src/constants';
import searchLineStyle from 'src/components/View/Header/searchLine.style';

const filterStyle = (theme) => ({
  root: {
    ...(searchLineStyle(theme)?.innerField || {}),
    cursor: 'pointer',

    '& .filterCount': {
      display: 'inline-block',
      minWidth: 22,
      minHeight: 22,
      padding: '0px 3px',
      marginLeft: 5,
      backgroundColor: STYLE_OPTIONS.COLOR_BLUE,
      color: '#ffffff',
      verticalAlign: 'middle',
      borderRadius: 20,
      fontSize: '10px',
      lineHeight: '22px',
      textAlign: 'center',
    },

    [theme.breakpoints.down('md')]: {
      position: 'inherit',
    },
  },

  innerFieldDropDown: {
    ...(searchLineStyle(theme)?.innerFieldDropDown || {}),
    cursor: 'default',
    [theme.breakpoints.down('md')]: {
      width: '90%',
      left: '5%',
      top: 100,
    },
  },
});

export default filterStyle;
